<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>数据字典</div>
      <div class='global-tbar'>
        <el-button size="small" type="primary" @click="insert">新增</el-button>
        <el-input size="small" placeholder="名称" v-model="condition.name"></el-input>
        <el-input size="small" placeholder="编码" v-model="condition.code"></el-input>
        <el-input size="small" placeholder="扩展" v-model="condition.ext"></el-input>
        <el-button size="small" type="default" @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <el-row>
        <el-col :span="6">
          <div class='global-title' style="width:100%;margin-top: 5px;margin-bottom: 5px;">
            <span>字典列表</span>
            <el-input size="mini" placeholder="类型" v-model="dictTypeCondition.type" style="width: 50%;line-height:20px;"></el-input>
            <el-button size="mini" type="default" @click="findDictType()">检索</el-button>
          </div>
          <div ref="dictTypeTable" style="overflow:scroll;width:100%;">
            <el-table :data="systemDictTypes" border stripe style="width: 100%" size="mini"
                      highlight-current-row @current-change="handleDictTypeChange">
              <el-table-column prop="type" label="字典类型" min-width="150"></el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col :span="18">
          <div ref="dictItemTable" style="overflow:scroll;width:100%;">
            <div class="global-paging" v-show="paging.allNum > paging.everySize" >
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
            <el-table :data="systemDicts" border stripe style="width: 100%" size="mini">
              <el-table-column prop="sortNo" label="排序" width="50"></el-table-column>
              <el-table-column prop="name" label="名称" min-width="100" sortable></el-table-column>
              <el-table-column prop="code" label="编码" width="100" sortable></el-table-column>
              <el-table-column prop="ext1" label="扩展1" width="100"></el-table-column>
              <el-table-column prop="ext2" label="扩展2" width="100"></el-table-column>
              <el-table-column prop="ext3" label="扩展3" width="100"></el-table-column>
              <el-table-column prop="ext4" label="扩展4" width="100"></el-table-column>
              <el-table-column prop="ext5" label="扩展5" width="100"></el-table-column>
              <el-table-column prop="status" label="状态" width="80">
                <template slot-scope="scope">
                  <span v-show="scope.row.status=='启用'" style="color:#67C23A">启用</span>
                  <span v-show="scope.row.status!='启用'" style="color:#F56C6C">停用</span>
                </template>
              </el-table-column>
              <el-table-column prop="isCombo" label="COMBO" width="80">
                <template slot-scope="scope">
                  <el-tag v-show="scope.row.isCombo" type="success">是</el-tag>
                  <el-tag v-show="!scope.row.isCombo" type="danger">否</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
                <el-button class="global-text-btn-danger" size="mini" type="text" @click="remove(scope.row)" style="margin-left: 10px;">删除</el-button>
              </template>
              </el-table-column>
            </el-table>
            <div class="global-paging" v-show="paging.allNum > paging.everySize" >
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  
  <!-- ---------------------- 编辑弹窗 ---------------------- -->
  
  <el-dialog :visible.sync="visible.editDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editDialog">
      <el-form ref="form" :model="systemDict" :rules="rules" label-width="60px" size="small">
        <el-form-item label="类型" prop="type">
          <el-input v-model="systemDict.type"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sortNo">
          <el-input-number v-model="systemDict.sortNo"></el-input-number>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="systemDict.name"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="systemDict.code"></el-input>
        </el-form-item>
        <el-form-item label="扩展1" prop="ext1">
          <el-input v-model="systemDict.ext1"></el-input>
        </el-form-item>
        <el-form-item label="扩展2" prop="ext2">
          <el-input v-model="systemDict.ext2"></el-input>
        </el-form-item>
        <el-form-item label="扩展3" prop="ext3">
          <el-input v-model="systemDict.ext3"></el-input>
        </el-form-item>
        <el-form-item label="扩展4" prop="ext4">
          <el-input v-model="systemDict.ext4"></el-input>
        </el-form-item>
        <el-form-item label="扩展5" prop="ext5">
          <el-input v-model="systemDict.ext5"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="systemDict.status">
            <el-option label="启用" value="启用"> </el-option>
            <el-option label="停用" value="停用"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="COMBO" prop="isCombo">
          <el-switch v-model="systemDict.isCombo"></el-switch>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="saveClose" >保存关闭</el-button>
        <el-button size="small" type="success" @click="saveAdd" >保存新增</el-button>
        <el-button size="small" type="default" @click="visible.editDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>
  
</div>
</template>

<script>

export default {
  name: 'SystemDictIndex',
  data () {
    return {
      // 数据字典列表
      systemDictTypes: [],
      // 数据字典列表
      systemDicts: [],
      // 遮罩
      loading: {main: false, editDialog: false},
      // 可见
      visible: {editDialog: false},
      // 条件
      currentDictType:null,
      // 条件
      dictTypeCondition:{},
      // 条件
      condition:{},
      // 数据字典
      systemDict: {},
      // 校验规则
      rules: {
        type: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        name: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        code: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        status: [
          { required: true, message: '该项必填', trigger: 'change' }
        ]
      },
      // 分页
      paging: {currPage: 1, everySize: 20, allNum: 0}
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
    vm.$refs.dictTypeTable.style.height = (window.innerHeight-vm.$baize.frameTitleHeight-130)+'px';
    vm.$refs.dictItemTable.style.height = (window.innerHeight-vm.$baize.frameTitleHeight-90)+'px';
    vm.findDictType();
  },
  
  methods: {
    /*
     * 查询字典类型
     */
    findDictType: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      // 请求后台
      vm.$http.get('rest/sys/systemDict/findDict', {params: vm.dictTypeCondition}).then(response => {
        vm.systemDictTypes = response.body.dictList;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    handleDictTypeChange: function (val) {
      let vm = this
      if(val!=null){
        vm.currentDictType = val.type;
        vm.findByCondition();
      } else {
        vm.currentDictType = null;
      }
    },
    /*
     * 查询所有
     */
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      params.type = vm.currentDictType
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/sys/systemDict/findByCondition', {params: params}).then(response => {
        vm.systemDicts = response.body.systemDicts;
        vm.paging = response.body.pagingBean;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    
    /*
     * 新增
     */
    insert: function () {
      var vm = this
      vm.visible.editDialog = true
      vm.systemDict = {type: vm.currentDictType,sortNo:0,status:"启用",isCombo:false}
    },
    
    /*
     * 编辑
     */
    edit: function (record) {
      var vm = this
      vm.visible.editDialog = true
      vm.systemDict = JSON.parse(JSON.stringify(record));
    },
    
    /*
     * 删除
     */
    remove: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.type+'_'+record.name + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.delete('rest/sys/systemDict/'+String(record.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition(vm.paging.currPage)
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    /*
     * 保存新增
     */
    saveAdd: function () {
      var vm = this;
      // 校验
      vm.$refs['form'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemDict/saveData', vm.systemDict).then(function (response) {
          vm.systemDict = response.body;
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          vm.systemDict.id = null;
          vm.systemDict.sortNo = vm.systemDict.sortNo+1;
          vm.systemDict.name = null;
          vm.systemDict.code = null;
          vm.systemDict.ext1 = null;
          vm.systemDict.ext2 = null;
          vm.systemDict.ext3 = null;
          vm.systemDict.ext4 = null;
          vm.systemDict.ext5 = null;
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    },
    /*
     * 保存关闭
     */
    saveClose: function () {
      var vm = this;
      // 校验
      vm.$refs['form'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemDict/saveData', vm.systemDict).then(function (response) {
          vm.systemDict = response.body;
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editDialog = false
          vm.findByCondition(vm.paging.currPage)
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/systemdict/SystemDictIndex.vue